export function parsePositiveQuantity(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) && value > 0 ? value : undefined;
  }

  if (value === null || value === undefined) return undefined;
  const match = String(value).trim().match(/\d+(?:[.,]\d+)?/);
  if (!match) return undefined;

  const parsed = Number(match[0].replace(',', '.'));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

export function formatUnits(quantity) {
  const formatted = Number.isInteger(quantity)
    ? String(quantity)
    : String(quantity).replace('.', ',');
  return `${formatted} ${quantity === 1 ? 'unidad' : 'unidades'}`;
}

export function getPurchaseRules(product = {}, initial = 1) {
  const fallback = parsePositiveQuantity(initial) || 1;
  const multiplier = parsePositiveQuantity(product.multiplicador);
  const minimum = parsePositiveQuantity(product.ventaMinima) || multiplier || fallback;
  const step = multiplier || 1;
  const unitsPerPresentation = parsePositiveQuantity(product.unidades);
  const rawPresentation = String(product.presentacion || '').trim();
  const presentation = rawPresentation
    || (unitsPerPresentation ? `${formatUnits(unitsPerPresentation)} por presentación` : '');

  return {
    minimum,
    step,
    presentation,
  };
}
